import React, { ComponentState, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppInput } from "../../../components/Input";
import { ErrorConsts } from "../../../utils/ErrorCons";
import { AppButtons } from "../../../components/button";
import { changePassword, savechangePasswordResponse } from "../../../redux/actions";
import { useNavigate } from "react-router-dom";

export interface ChangePasswordProps {
    onClose(): void,
    title?: string,
    subtitle?:string,
    isTempPassword?:boolean
}

export const ChangePassword: React.FC<ChangePasswordProps> = ({ onClose, title, subtitle,isTempPassword }) => {
    const state: ComponentState = useSelector(states => {
        return states;
    });
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [buttonPressed, setButtonPressed] = useState<boolean>(false)
    const [oldPassword, setOldPassword] = useState<string>()
    const [newPassword, setNewPassword] = useState<string>("")
    const [confirmPassword, setConfirmPassword] = useState<string>("")
    const [error, setError] = useState<boolean>(false)
    const { changePasswordResponse } = state['AuthReducer']
    const { loadingState } = state['LoaderReducer'];

    useEffect(() => {
        if (changePasswordResponse) {
            if (changePasswordResponse?.status === true) {
                localStorage.clear()
                setTimeout(() => {
                    onClose()
                    dispatch(savechangePasswordResponse())
                    navigate('/logIn')
                }, 4000)
            }

        }
    })
    const handleButtonPressed = () => {
        setButtonPressed(true)
        if ((newPassword !== confirmPassword) && (newPassword?.length > 0 && confirmPassword?.length > 0)) {
            setError(true)
            return;
        }
        if (newPassword == confirmPassword) {
            setError(false)
        }
        if (newPassword?.length !== 0 && confirmPassword?.length !== 0) {
            const data = {
                oldPassword: oldPassword,
                newPassword: newPassword,
            }
            dispatch(changePassword(data))
        }
    }

    const handleClose = () => {
        dispatch(savechangePasswordResponse())
        onClose()
    }

    return (
        <>
            <div className="modal-wrapper">
                <div className="modal-Div my-3">
                    <button className="close-btn" onClick={handleClose}>
                        <i className="fa-regular fa-circle-xmark"></i>
                    </button>
                    <h2 className="fw-600">{title}
                    </h2>
                    <h6 className="mb-3 fw-600">{subtitle}
                    </h6>
                    <form>

                        <AppInput labelText="Current Password"
                            inputType="text"
                            inputmode="text"
                            showError={buttonPressed && (!oldPassword || oldPassword.length < 4)}
                            errorMessage={ErrorConsts.CURRENT_PASSWORD}
                            onChange={setOldPassword}></AppInput>

                        <AppInput labelText="New Password"
                            inputType="password"
                            inputmode="text"
                            showError={buttonPressed && (!newPassword || newPassword.length < 8)}
                            errorMessage={ErrorConsts.NEW_PASSWORD}
                            onChange={setNewPassword}></AppInput>

                        <AppInput labelText="Confirm Password"
                            inputType="password"
                            inputmode="text"
                            showError={buttonPressed && (!confirmPassword || confirmPassword.length < 8)}
                            errorMessage={ErrorConsts.CONFIRM_PASSWORD}
                            onChange={setConfirmPassword}></AppInput>
                        {error &&

                            <p className="mb-3 mt-2 fw-600 error-message text-left m-0 f-14 fw-400 mb-0"> New password and confirm password don't match. </p>

                        }
                        <div className="d-flex gap-2 align-items-center">
                            <AppButtons buttonText="Submit" className="btn-common  btn-green" onclick={handleButtonPressed} loadingState={loadingState} ></AppButtons>
                            <AppButtons className="btn-common white-btn  text-center" buttonText="Cancel" onclick={handleClose} ></AppButtons>
                        </div>
                        {changePasswordResponse?.status === true ? <p className="mb-3 mt-2 fw-600 success-message text-left m-0 f-14 fw-400 mb-0"> {isTempPassword?'Your password is updated successfully, Please login using your new password':changePasswordResponse?.message} </p> : changePasswordResponse?.status === false ? <p className="mb-3 mt-2 fw-600 error-message text-left m-0 f-14 fw-400 mb-0">{changePasswordResponse?.message}</p> : null}
                    </form>
                </div>
            </div>
        </>
    )
}